// console.log("📦 [Apollo Module] setupApollo.tsx loaded");

import {
  ApolloClient,
  DefaultOptions,
  FetchPolicy,
  InMemoryCache,
  createHttpLink,
  split,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import {
  getMainDefinition,
  offsetLimitPagination,
} from "@apollo/client/utilities";
import { persistCache } from "apollo-cache-persist";

// export const persistentToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6ImsxIn0.eyJpc3MiOiJodHRwczovL3N0YWdpbmctZ3FsLmZhcm1pbnN0YS5jb20vYXBpL2dyYXBocWxpdGUiLCJpYXQiOjE3Mjc2ODgzNTQsImV4cCI6MTc0MzI0MDM1NCwibmJmIjoxNzI3Njg4MzU0LCJqdGkiOiJUTHJvMzhtM1ZaVzdOZzNHIiwic3ViIjoiMDFIQ1c5UzhKUE1OME1OR01BWEszS1BQU1YiLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3Iiwicm9sZXMiOlsiZmktY29tcGFueS1hZG1pbiJdLCJjb21wYW55X2lkIjoiMDFINFhRN0FZSkFGRDQ3QVgwODhHNzJUUkciLCJwaG9uZSI6Ijc3OTk4ODg2NDUiLCJlbWFpbCI6ImNvbnRhY3RAZmFybWluc3RhLmNvbSJ9.ec39QkcYmh59hPxIgmmECsRc14xxEn9wtdS4smJig4xUy7Mp0-nwoKTp-IrBAVvhj96ZtxLaCSkc0JuwyH5ZTNACPuqhbZHOpvaJymxZQ0Y7FEFMpwU7BDPYSUe8zjd9lw7Vx4Lz2MRmLv3gabrLxpwMt5Rhbohd5cFaudMYwQAj8vp3l7NMh3iBGuh__pYLnnmHDJMOeZFFnorNBW_Zi0n_XdOhdrj0dPIPoqUpbtaAPJRSYAKT2rPHDpzUFIjmoh3v3rvXskXlgSiZ-XwgVjYYS_Me7gs4pmW8kmsMB7azDTYhjiDJDJf4_jPGX8w8EnBwo51SvhW7-_Q4ZXwEVSDlVU2Ji-oY_kvxVfguHkEIcW2Dl3OmBKwc3V--bhn2iA2NxJc60y5bETuecMzFwroQjqYNybO-adEOdgHfhOeB0s9OHP03mbUuHW3DEfle45B0D8DrZ3vu5_Xggw4GXba-Qfe5prAc8Vfiz7NDHMCtKI7JlAgyEPj3T6-CzXmz9a3T57BeQ-tkK5sc5dpq6P5LwVn32mhMPJuSUO3-67g0u1lRwgqdRKXHIDLx-UfnVibZDlxZEw1io1VcGWHipeKvS-od4QDCWejDwsNcdfD1-pox4NuUp-zJJREZxLKH4rkpqIEyJ9P-4qZlbd9Xs6Belg7VQ26y3TPt4sIK1mU";
export const persistentToken =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6ImsxIn0.eyJpc3MiOiJodHRwczovL2dxbC5mYXJtaW5zdGEuY29tL2dyYXBocWwiLCJpYXQiOjE3Mjc2ODgzNTQsImV4cCI6MTc5MzI0MDM1NCwibmJmIjoxNzI3Njg4MzU0LCJqdGkiOiJUTHJvMzhtM1ZaVzdOZzNHIiwic3ViIjoiMDFKUUszSFBWU1NQR0NKVFBZQzJaQllDSk0iLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3Iiwicm9sZXMiOlsiYW5vbnltb3VzIl0sImNvbXBhbnlfaWQiOiIwMUpRSzNIUFZTUTgzQTRFOVEzUDI1S0FYMSIsInBob25lIjoiMDAwMDAwMDAwMCIsImVtYWlsIjoiZ3Vlc3RAZmFybWluc3RhLmNvbSJ9.ZSIZC3vu-OPllqGANhUOHy67qAsUJcY7oUj1ObZ7Ajj9tyog7fgz0R7su1BadG_BpkA6jtG9vbNqReiIfmY5pT3P_zUQgh1o1GuUk8LnNrg17663Af2yWA9DeEcoO8FJCr7hL4YeGf0j8hM2jBlREHCxgWGcR8spmegY4zaWkf9vEqJKxtyPcZ-0RmHUSDnlmm7LFxv9J1Ejm7wZiCvwa3i7cH0APDYGiIZm16Zm7riKYQPW0t_xUS1G738S6qkHjHxhAWSmgCJl2cAkSTvFWPCFf6bl5VNzDB_BWpI8IPxwBo-wE606MnaoNnfKuncTCkhlEYSwNPdxGUflVLYqZlObRvUjIES7JXY9s2wCpZj7MFou4GbJdWzFOgYH_375FDcObGiONhEYxkEbaiv_vmlW6yJQuKuTgJK1gCAsGzs_OT_H-lwW7KALQ7coOE3lFDuEg4DSzMJbaRPjqNWJjKizB-uXCYYyuSzkEqNL1XAuUouVpSSA5lDAeckH5_QzmX8z3RMsW9Ca6jyK_L-WubdAHDcDxkwe46vlqrc9rPnclSEDgTLVDI7AgIBVT-vwFOQjZBAFNm-OXszF4hiKLldfNVsgHUmOEWqaincHIYPOWU962wBMRI-t2ka7Pll_V5vdvbOOblmZwXNPumzLn_cRjcWuFGfD5PBJFENZPK8";

// Function to get the GraphQL endpoint based on hostname
const getGraphQLEndpoint = () => {
  if (typeof window === "undefined") {
    // Server-side rendering fallback - use environment variables if available
    // console.log("🔧 [Apollo] Server-side rendering - using environment variables or defaults");
    return {
      http: process.env.NEXT_PUBLIC_BASE_URL_HTTPS || "https://gql.farminsta.com/v1/graphql",
      ws: process.env.NEXT_PUBLIC_BASE_URL_WSS || "wss://gql.farminsta.com/v1/graphql",
    };
  }

  const hostname = window.location.hostname;
  // console.log(`🔧 [Apollo] Current hostname: ${hostname}`);

  // Check if hostname contains specific subdomain patterns
  if (hostname.includes('staging')) {
  //  if (hostname.includes('staging') || (hostname.includes('localhost'))) {
    const endpoints = {
      http: "https://staging-gql.farminsta.com/v1/graphql",
      ws: "wss://staging-gql.farminsta.com/v1/graphql",
    };
    return endpoints;
  }
  if (hostname.includes("pgweb-kaveri")) {
    const endpoints = {
      http: "https://pggql-kaveri.farminsta.com/v1/graphql",
      wss: "wss://pggql-kaveri.farminsta.com/v1/graphql",
    };
    // console.log("🎯 [Apollo] Using GrowthBook endpoints:", endpoints);
    return endpoints;
  }

  if (hostname.includes("growthbook")) {
    const endpoints = {
      http: "https://gql-growthbook.farminsta.com/v1/graphql",
      ws: "wss://gql-growthbook.farminsta.com/v1/graphql",
    };
    // console.log("🎯 [Apollo] Using GrowthBook endpoints:", endpoints);
    return endpoints;
  }
  if (hostname.includes("gbook")) {
    const endpoints = {
      http: "https://gql-gbook.farminsta.com/v1/graphql",
      ws: "wss://gql-gbook.farminsta.com/v1/graphql",
    };
    // console.log("🎯 [Apollo] Using GrowthBook endpoints:", endpoints);
    return endpoints;
  }

  // Add more hostname patterns as needed
  // Example: if (hostname.includes('staging')) { return staging endpoints }

  // Default fallback
  const defaultEndpoints = {
    http: "https://gql.farminsta.com/v1/graphql",
    ws: "wss://gql.farminsta.com/v1/graphql",
  };
  // console.log("🔧 [Apollo] Using default endpoints:", defaultEndpoints);
  return defaultEndpoints;
};

let client: ApolloClient<any> | null = null;
let currentHostname: string | null = null;

const createApolloClient = () => {
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : null;

  // Recreate client if hostname changed or client doesn't exist
  if (!client || currentHostname !== hostname) {
    // console.log(`🔄 [Apollo] Creating new client for hostname: ${hostname}`);
    // console.log(`🔄 [Apollo] Previous hostname was: ${currentHostname}`);
    currentHostname = hostname;
    const authLink = setContext(() => {
      const token1 = localStorage.getItem("GQL_TOKEN");
      // const { headers, url } = defContext;

      // console.log({GQLRewrite: defContext, operationName: operation.operationName});
      return {
        // url: url + '/?operationName=' + operation.operationName,
        headers: {
          Authorization: `Bearer ${token1 || persistentToken}`,
        },
      };
    });
    const endpoints = getGraphQLEndpoint();

    // Always prioritize hostname-based endpoints over environment variables
    // Environment variables are only used as fallback for server-side rendering
    const BASE_URL = endpoints.http;
    const BASE_URL_WSS = endpoints.ws;

    // console.log("🚀 [Apollo] Final endpoints configured:");
    // console.log("   HTTP:", BASE_URL);
    // console.log("   WebSocket:", BASE_URL_WSS);
    // console.log("   Source: hostname-based detection");
    // console.log("   Environment override ignored:", {
    //   NEXT_PUBLIC_BASE_URL_HTTPS: process.env.NEXT_PUBLIC_BASE_URL_HTTPS,
    //   NEXT_PUBLIC_BASE_URL_WSS: process.env.NEXT_PUBLIC_BASE_URL_WSS
    // });

    const customHttpLink = new ApolloLink((operation, forward) => {
      const operationName = operation.operationName;
      const context = operation.getContext();
      const http = context?.http || {};

      const baseUrl = http.uri || BASE_URL; // fallback to /graphql if not specified
      const separator = baseUrl.includes("?") ? "&" : "?";
      const modifiedUri = `${baseUrl}${separator}opname=${operationName}`;

      operation.setContext({
        ...context,
        uri: modifiedUri,
      });

      return forward(operation);
    });
    const cache = new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            // "pf_plan_cards": offsetLimitPagination(),
            // "gigs": offsetLimitPagination(),
            service_requests: offsetLimitPagination(),
            prospect_messages: offsetLimitPagination(),
            ActiveUsers: offsetLimitPagination(),
            //    "fich_farminsta_replica_leads":offsetLimitPagination()
          },
        },
      },
    });
    const httpLink = createHttpLink({
      uri: BASE_URL,
      // headers: {
      //     Authorization: `Bearer ${token || persistentToken}`,
      // }
    });
    const wsLink = new GraphQLWsLink(
      createClient({
        url: BASE_URL_WSS,
        connectionParams: () => {
          const token = localStorage.getItem("GQL_TOKEN");
          // console.log({wsLink: getBaseUrls()?.https || "", wssToken: token})

          return {
            headers: {
              Authorization: `Bearer ${token || persistentToken}`,
            },
          };
        },
      })
    );
    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        // console.log({ definition })
        return (
          definition.kind === "OperationDefinition" &&
          definition.operation === "subscription"
        );
      },
      wsLink,
      httpLink
    );
    if (typeof window !== "undefined") {
      persistCache({
        cache,
        storage: window.localStorage,
      });
    }
    const defaultOptions: DefaultOptions = {
      query: {
        fetchPolicy: "cache-and-network" as FetchPolicy,
        errorPolicy: "all",
      },
      mutate: {
        errorPolicy: "all",
      },
    };

    client = new ApolloClient({
      link: ApolloLink.from([customHttpLink, authLink.concat(splitLink)]),
      cache,
      // name: "Farminsta GraphQL Client",
      // version: "1.0",
      defaultOptions,
    });
  }
  return client;
};

// Function to reset the Apollo client (useful for testing or hostname changes)
export const resetApolloClient = () => {
  // console.log("🔄 [Apollo] Resetting client");
  client = null;
  currentHostname = null;
};

// Debug function to check current state
export const debugApolloState = () => {
  // console.log("🐛 [Apollo Debug] Current state:");
  // console.log("   Client exists:", !!client);
  // console.log("   Current hostname:", currentHostname);
  // console.log("   Window hostname:", typeof window !== "undefined" ? window.location.hostname : "N/A");
  // console.log("   Window location:", typeof window !== "undefined" ? window.location.href : "N/A");

  if (typeof window !== "undefined") {
    const endpoints = getGraphQLEndpoint();
    // console.log("   Expected endpoints:", endpoints);
  }
};

// Make debug function available globally for testing
if (typeof window !== "undefined") {
  (window as any).debugApollo = debugApolloState;
}

export default createApolloClient;
